import useAppState from '../hooks/use-app-state'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const useInternationalSite = () => {
    const {
        preferences: {disableEcommerce}
    } = useAppState()

    const {locale} = useMultiSite()
    const currentLocale = locale?.id || ''
    const normalizedLocale = currentLocale.replace('-', '_')

    const isDisabled =
        disableEcommerce?.indexOf(currentLocale) !== -1 ||
        disableEcommerce?.indexOf(normalizedLocale) !== -1
    return locale?.id?.toLowerCase() === 'default' || isDisabled
}
export default useInternationalSite
